import { render, staticRenderFns } from "./CuponesTabla.vue?vue&type=template&id=1eac4cb5&"
import script from "./CuponesTabla.vue?vue&type=script&lang=js&"
export * from "./CuponesTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports